import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import DownloadFile from '../ContextMenu/WorkflowGroupActions/DownloadFile';
import DataObjectOutlinedIcon from '@mui/icons-material/DataObjectOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';


function InvalidJSONResponse({ open, handleClose, fileName }) {
    const { t } = useTranslation();
    const [downloadFile, setDownloadFile] = React.useState(false);
    
    const handleDownLoad = () => {
      setDownloadFile(true);
    };
    
    const handleToggle = (val) => {
        setDownloadFile(val);
        handleClose(false);
    }
    
  return (
    <>
      <Dialog open={open} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div
            className="flex"
            style={{ justifyContent: "space-between", alignItems: "center"}}>
            <div className="title">{t("LBL_FILE_DOWNLOAD")}</div>
            <Button
              size="small"
              variant='text'
              onClick={() => handleClose(false)}>
              <CloseOutlinedIcon />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          <div className="dialog-content">
            <div className="file-info">
              <div className="file-icon-container">
                <DataObjectOutlinedIcon className="file-icon" />
              </div>
              <div className="file-details">
                <p className="file-name">{t('LBL_NAME')} {fileName}</p>
                <p className="file-type">JSON Source file</p>
              </div>
            </div>
            <p className="dialog-message">{t('FILE_DOWNLOAD_DESC')}</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleDownLoad}>
            {t("DOWNLOAD")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => handleClose(false)}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      {downloadFile && (
        <DownloadFile open={downloadFile} toggle={(val) => handleToggle(val)} />
      )}
    </>
  );
}

export default InvalidJSONResponse